import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "mb-4" }, "Bulk Email", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "form-group row mb-4 d-flex align-items-end" }
const _hoisted_6 = { class: "col-md-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "csv_file",
  class: "col-form-label text-md-right"
}, "Import a CSV", -1)
const _hoisted_8 = ["value"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", { class: "col-md-1 btn btn-info" }, " Import ", -1)
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "user_types",
  class: "col-form-label text-md-right"
}, [
  /*#__PURE__*/_createTextVNode("User Types "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_12 = { class: "col-md-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "fund_types",
  class: "col-form-label text-md-right"
}, "Fund Types", -1)
const _hoisted_14 = {
  key: 0,
  class: "form-group row mb-4"
}
const _hoisted_15 = { class: "row" }
const _hoisted_16 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  for: "hw_types",
  class: "col-form-label text-md-right"
}, "H&W Types", -1)
const _hoisted_18 = {
  key: 1,
  class: "col-md-4"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "annuity_types",
  class: "col-form-label text-md-right"
}, "Annuity Types", -1)
const _hoisted_20 = {
  key: 2,
  class: "col-md-4"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  for: "pension_types",
  class: "col-form-label text-md-right"
}, "Pension Types", -1)
const _hoisted_22 = {
  key: 0,
  class: "row mt-4"
}
const _hoisted_23 = { class: "col-md-4" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  for: "pension_additional",
  class: "col-form-label text-md-right"
}, "Pension Additional", -1)
const _hoisted_25 = ["value"]
const _hoisted_26 = {
  key: 0,
  class: "d-flex align-items-center gap-4 col-md-8"
}
const _hoisted_27 = { class: "col-md-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  for: "start_date",
  class: "col-form-label text-md-right"
}, "Start Date", -1)
const _hoisted_29 = { class: "col-md-3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  for: "end_date",
  class: "col-form-label text-md-right"
}, "End Date", -1)
const _hoisted_31 = {
  key: 1,
  class: "row mt-4"
}
const _hoisted_32 = { class: "col-md-4" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", {
  for: "hw_additional",
  class: "col-form-label text-md-right"
}, "HW Additional", -1)
const _hoisted_34 = ["value"]
const _hoisted_35 = {
  key: 0,
  class: "d-flex align-items-center gap-4 col-md-8"
}
const _hoisted_36 = { class: "col-md-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", {
  for: "start_date",
  class: "col-form-label text-md-right"
}, "Start Date", -1)
const _hoisted_38 = { class: "col-md-3" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", {
  for: "end_date",
  class: "col-form-label text-md-right"
}, "End Date", -1)
const _hoisted_40 = {
  class: "form-group row mb-4",
  id: "user_filters"
}
const _hoisted_41 = { class: "col-md-3" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", {
  for: "home_locals",
  class: "col-form-label text-md-right"
}, "Home Locals", -1)
const _hoisted_43 = { class: "col-md-3" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  for: "marital_status",
  class: "col-form-label text-md-right"
}, "Marital Status", -1)
const _hoisted_45 = { class: "col-md-3" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "col-form-label text-md-right"
}, "State", -1)
const _hoisted_47 = { class: "col-md-3" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", {
  for: "zip_code",
  class: "col-form-label text-md-right"
}, "Zip Code", -1)
const _hoisted_49 = { class: "col-md-4 d-flex align-items-center gap-4 mb-4" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { for: "foreign_participants" }, " Send to Foreign Participants Only ", -1)
const _hoisted_51 = { class: "form-group row mb-4" }
const _hoisted_52 = { class: "col-md-6" }
const _hoisted_53 = { class: "col-md-6 d-flex justify-content-end gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alerts = _resolveComponent("Alerts")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Alerts, {
      success: $setup.success,
      errors: $setup.error
    }, null, 8, ["success", "errors"]),
    _hoisted_2,
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Loading... "))
      : (_openBlock(), _createElementBlock("form", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("input", {
                type: "file",
                id: "csv_file",
                accept: ".csv",
                class: "form-control",
                value: $setup.csvFile
              }, null, 8, _hoisted_8)
            ]),
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_multiselect, {
                modelValue: $setup.selectedUserTypes,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedUserTypes) = $event)),
                options: $setup.userTypes,
                label: "RoleName",
                "track-by": "RoleID",
                placeholder: "Select User Types",
                multiple: true,
                onSelect: $setup.handleUserTypeChange,
                required: ""
              }, null, 8, ["modelValue", "options", "onSelect"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_multiselect, {
                modelValue: $setup.selectedFundTypes,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.selectedFundTypes) = $event)),
                options: $setup.fundTypes,
                placeholder: "Select Fund Types",
                multiple: true,
                onSelect: $setup.handleFundTypeChange
              }, null, 8, ["modelValue", "options", "onSelect"])
            ])
          ]),
          ($setup.selectedFundTypes.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  ($setup.isHWSelected || $setup.isAllFunds)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _hoisted_17,
                        _createVNode(_component_multiselect, {
                          modelValue: $setup.selectedHWTypes,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.selectedHWTypes) = $event)),
                          options: $setup.hwTypes,
                          placeholder: "Select H&W Types",
                          multiple: true,
                          onSelect: $setup.handleHWTypeChange
                        }, null, 8, ["modelValue", "options", "onSelect"])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.isAnnuitySelected || $setup.isAllFunds)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _hoisted_19,
                        _createVNode(_component_multiselect, {
                          modelValue: $setup.selectedAnnuityTypes,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.selectedAnnuityTypes) = $event)),
                          options: $setup.annuityTypes,
                          "track-by": "key",
                          label: "value",
                          placeholder: "Select Annuity Types",
                          multiple: true,
                          onSelect: $setup.handleAnnuityTypeChange
                        }, null, 8, ["modelValue", "options", "onSelect"])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.isPensionSelected || $setup.isAllFunds)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _hoisted_21,
                        _createVNode(_component_multiselect, {
                          modelValue: $setup.selectedPensionTypes,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.selectedPensionTypes) = $event)),
                          options: $setup.pensionTypes,
                          "track-by": "key",
                          label: "value",
                          placeholder: "Select Pension Types",
                          multiple: true,
                          onSelect: $setup.handlePensionTypeChange
                        }, null, 8, ["modelValue", "options", "onSelect"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            ($setup.isPensionSelected || $setup.isAllFunds)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.pension.Selected) = $event)),
                      class: "form-control",
                      id: "pension_additional"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pensionAdditional, (value, key) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: key,
                          value: key
                        }, _toDisplayString(value), 9, _hoisted_25))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, $setup.pension.Selected]
                    ])
                  ]),
                  ($setup.showPensionDates)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _hoisted_28,
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.pension.StartDate) = $event)),
                            class: "form-control",
                            id: "start_date"
                          }, null, 512), [
                            [_vModelText, $setup.pension.StartDate]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _hoisted_30,
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.pension.EndDate) = $event)),
                            class: "form-control",
                            id: "end_date"
                          }, null, 512), [
                            [_vModelText, $setup.pension.EndDate]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            ($setup.isHWSelected || $setup.isAllFunds)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.hw.Selected) = $event)),
                      class: "form-control",
                      id: "hw_additional"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.hwAdditional, (value, key) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: key,
                          value: key
                        }, _toDisplayString(value), 9, _hoisted_34))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, $setup.hw.Selected]
                    ])
                  ]),
                  ($setup.showHWDates)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _hoisted_37,
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.hw.StartDate) = $event)),
                            class: "form-control",
                            id: "start_date"
                          }, null, 512), [
                            [_vModelText, $setup.hw.StartDate]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _hoisted_39,
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.hw.EndDate) = $event)),
                            class: "form-control",
                            id: "end_date"
                          }, null, 512), [
                            [_vModelText, $setup.hw.EndDate]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _createVNode(_component_multiselect, {
                  modelValue: $setup.selectedHomeLocals,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.selectedHomeLocals) = $event)),
                  options: $setup.participantFilters.locals,
                  "track-by": "LocalID",
                  label: "Area",
                  placeholder: "Select Home Local",
                  multiple: true,
                  disabled: !$setup.isActive,
                  onSelect: $setup.handleLocalChange
                }, null, 8, ["modelValue", "options", "disabled", "onSelect"])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createVNode(_component_multiselect, {
                  modelValue: $setup.selectedMaritalStatuses,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.selectedMaritalStatuses) = $event)),
                  options: $setup.participantFilters.maritalStatuses,
                  "track-by": "CodeID",
                  label: "Description",
                  placeholder: "Select Home Local",
                  multiple: true,
                  disabled: !$setup.isActive,
                  onSelect: $setup.handleMaritalStatusChange
                }, null, 8, ["modelValue", "options", "disabled", "onSelect"])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createVNode(_component_multiselect, {
                  modelValue: $setup.selectedStates,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.selectedStates) = $event)),
                  options: $setup.participantFilters.states,
                  "track-by": "ShortName",
                  label: "LongName",
                  placeholder: "Select Home Local",
                  multiple: true,
                  disabled: !$setup.isActive,
                  onSelect: $setup.handleStateChange
                }, null, 8, ["modelValue", "options", "disabled", "onSelect"])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createVNode(_component_multiselect, {
                  modelValue: $setup.selectedZipCodes,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.selectedZipCodes) = $event)),
                  options: $setup.participantFilters.zipCodes,
                  placeholder: "Select Home Local",
                  multiple: true,
                  disabled: !$setup.isActive,
                  onSearchChange: $setup.searchZipCodes,
                  onSelect: $setup.handleZipCodeChange
                }, null, 8, ["modelValue", "options", "disabled", "onSearchChange", "onSelect"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "foreign_participants",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.foreignOnly) = $event))
            }, null, 512), [
              [_vModelCheckbox, $setup.foreignOnly]
            ]),
            _hoisted_50
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createVNode(_component_router_link, {
                to: { name: 'superadmin.dashboard' },
                class: "btn btn-primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(('Back')))
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.handleSubmit('Export')))
              }, _toDisplayString(('Export CSV'))),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.handleSubmit('Compose')))
              }, _toDisplayString(('Compose')))
            ])
          ])
        ]))
  ]))
}